<div class="zazz-calendar-container">
    <div class="loader" *ngIf="isLoading()">
        <fa-icon [icon]="icons.faSpinner" [animation]="'spin'"></fa-icon>
    </div>
    <div class="calendar-header">
        <div class="controls">
            <button class="btn-control" [disabled]="isBatchUpdating()" (click)="dateChange('prev')">
                <fa-icon [icon]="icons.faArrowLeft" size="2x"></fa-icon>
            </button>
            <button class="btn-control" [disabled]="isBatchUpdating()" (click)="dateChange('next')">
                <fa-icon [icon]="icons.faArrowRight" size="2x"></fa-icon>
            </button>
            <span class="current-month">{{currentDate}}</span>
        </div>

        <div class="filters">
            <div class="filter-container">
                <select [(ngModel)]="settlementType" class="form-select form-select-lg" [disabled]="isBatchUpdating()">
                <option selected [value]="null" disabled>Tipo de cliente</option>
                <option [ngValue]="2">Todos</option>
                <option [ngValue]="0">Condominio</option>
                <option [ngValue]="1">Comercio</option>
            </select>
            </div>

            <div class="filter-container">
                <app-infinite-select [disabled]="isBatchUpdating() || !settlementTypeValid(true)" [settlementType]="settlementType()" [fetchPage]="settlementsFetcher" [pageSize]="settlementsPageSize" [labelKey]="'name'"
                [valueKey]="'id'" [placeholder]="'Condominio/Comercio'" [panelMaxHeight]="260" [triggerClass]="'form-select'"
                [showCaret]="false" [seedItems]="seededSettlements" (selectionChange)="selectSettlement($event)"
                [(selectedSettlement)]="selectedSettlement"></app-infinite-select>
            </div>

            <div class="filter-container">
                <select [(ngModel)]="unitStatus" class="form-select form-select-lg" [disabled]="isBatchUpdating()">
                <option selected [value]="null" disabled>Estatus de unidad</option>
                <option [ngValue]="1">Activo</option>
                <option [ngValue]="2">Inactivo</option>
            </select>
            </div>

            <div class="filter-container">
                <select [(ngModel)]="eventType" class="form-select form-select-lg" [disabled]="isBatchUpdating()">
                    <option [ngValue]="null" disabled>Tipo de evento</option>
                    @for (group of calendarEventTypeGroups(); track group.key) {
                        <optgroup [label]="group.label">
                            @for (event of group.events; track event.id) {
                                <option [ngValue]="event.id">{{ event.description }}</option>
                            }
                        </optgroup>
                    }
                </select>
            </div>
        </div>

        <div class="views">
            <select class="form-select form-select-lg" [(ngModel)]="selectedView" [disabled]="isBatchUpdating()" (change)="changeView()">
                <option *ngFor="let view of views"
                [value]="view.code"
                [selected]="view.code === selectedView">
                    {{view.name}}</option>
            </select>
        </div>

        <div class="municipality-filter-row">
            <input
                type="text"
                class="form-control form-control-lg"
                [(ngModel)]="municipality"
                [disabled]="isBatchUpdating()"
                placeholder="Municipio"
            >
        </div>

        <div class="calendar-actions">
            <button class="btn shadow-sm" [disabled]="isBatchUpdating()" (click)="clearFilters()">Limpiar</button>
            <button class="btn btn-zazz-dark shadow-sm" [disabled]="isBatchUpdating()" (click)="applyFilters()">Aplicar</button>
        </div>
    </div>

    @if (selectedCount() > 0) {
        <section class="batch-actions" aria-live="polite" aria-label="Actualización de tareas seleccionadas">
            <div class="batch-actions__selection">
                <div class="batch-actions__summary">
                    <strong>{{ selectedCount() }}</strong>
                    {{ selectedCount() === 1 ? 'tarea seleccionada' : 'tareas seleccionadas' }}
                </div>

                @if (selectionGroup(); as group) {
                    <div class="batch-actions__context">
                        <span>Condominio</span>
                        <strong>{{ group.settlementName || 'Sin nombre' }}</strong>
                    </div>
                    <button
                        type="button"
                        class="btn btn-sm btn-outline-dark batch-actions__select-all"
                        [disabled]="isBatchUpdating() || group.allSelected"
                        [attr.aria-label]="'Seleccionar las ' + group.unitCount + ' unidades elegibles de ' + (group.settlementName || 'este condominio')"
                        title="Selecciona las tareas elegibles según los filtros actuales"
                        (click)="selectAllSelectionGroup()"
                    >
                        {{ group.allSelected ? 'Todas las unidades seleccionadas' : 'Seleccionar todas las unidades' }}
                        ({{ group.unitCount }})
                    </button>
                }
            </div>

            <label class="batch-actions__status" for="batch-event-status">
                <span>Nuevo estado</span>
                <select
                    id="batch-event-status"
                    class="form-select"
                    [ngModel]="batchStatusId()"
                    [disabled]="isBatchUpdating()"
                    (ngModelChange)="batchStatusId.set($event)"
                >
                    <option [ngValue]="null">Selecciona un estado</option>
                    @for (status of batchStatusOptions(); track status.id) {
                        <option [ngValue]="status.id">{{ status.description || status.name }}</option>
                    }
                </select>
            </label>

            <div class="batch-actions__buttons">
                <button
                    type="button"
                    class="btn btn-zazz-default"
                    [disabled]="isBatchUpdating()"
                    (click)="clearBatchSelection()"
                >
                    Cancelar
                </button>
                <button
                    type="button"
                    class="btn btn-zazz-dark"
                    [disabled]="isBatchUpdating() || batchStatusId() === null"
                    (click)="applyBatchStatus()"
                >
                    @if (isBatchUpdating()) {
                        <fa-icon [icon]="icons.faSpinner" [animation]="'spin'" class="me-2"></fa-icon>
                    }
                    {{ isBatchUpdating() ? 'Actualizando…' : 'Actualizar estado' }}
                </button>
                @if (isBatchUpdating()) {
                    <div
                        class="batch-progress"
                        role="progressbar"
                        aria-label="Progreso de actualización de tareas"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        [attr.aria-valuenow]="batchProgressPercent()"
                        [attr.aria-valuetext]="batchCompletedCount() + ' de ' + batchTotalCount() + ' solicitudes completadas'"
                    >
                        <span class="batch-progress__ring" aria-hidden="true">
                            <svg viewBox="0 0 44 44">
                                <circle class="batch-progress__track" cx="22" cy="22" r="18" pathLength="100"></circle>
                                <circle
                                    class="batch-progress__value"
                                    cx="22"
                                    cy="22"
                                    r="18"
                                    pathLength="100"
                                    [attr.stroke-dashoffset]="100 - batchProgressPercent()"
                                ></circle>
                            </svg>
                            <strong>{{ batchProgressPercent() }}%</strong>
                        </span>
                        <span class="batch-progress__count">
                            {{ batchCompletedCount() }} de {{ batchTotalCount() }}
                        </span>
                    </div>
                }
            </div>
        </section>
    }

    <div class="calendar-container">
        <full-calendar [options]="calendarOptions"></full-calendar>
    </div>
</div>
